import React, { useState, useEffect, useRef } from 'react'
import moment from 'moment'
import dayjs from 'dayjs'
import { useSelector } from 'react-redux'
import { paginationInit, formatMessageNew, downLoadFileBlob, formatStartTime, formatEndTime } from '@/utils/common'
import {
  getAllDropDownList,
  getRsoDetaiReportlList,
  getOverdueConfiguration,
  exportRsoDetailReport
} from '@/services/rfid/defectiveReturn/defectiveReturn'
import { Card } from 'antd'
import SearchBar from '@/components/searchbar/SearchBar'
import AntdTable from '@/components/table/AntdTable'
import ActionBar from '@/components/table/ActionBar'

const searchItemSpan = { xl: 8, xxl: 8 }
const formItemLayout = {
  labelCol: { span: 10 },
  wrapperCol: { span: 14 }
}
const dateFormat = 'YYYY-MM-DD'
const scanDateStart = dayjs().subtract(1, 'day')
const scanDateEnd = dayjs()
const renderColumn = text => {
  return <div className="word_break_all">{text}</div>
}
const searchListInit = [
  {
    type: 'timeRange',
    label: 'languageObj.defectiveReturnLocale.scanDate',
    key: 'ScanDate',
    format: dateFormat,
    disabledDate: current => {
      let falg = current && current > moment().endOf('day')
      return falg
    },
    initialValues: [scanDateStart, scanDateEnd],
    spans: searchItemSpan,
    isdefaultfilter: 'true'
  },
  {
    type: 'select',
    label: 'languageObj.defectiveReturnLocale.validationResult',
    key: 'validationResult',
    selectAllClear: true,
    selectList: [
      { label: 'Unable To Validate', value: 'Unable To Validate' },
      { label: 'Overdue', value: 'Overdue' },
      { label: 'Normal', value: 'Normal' }
    ],
    spans: searchItemSpan,
    isdefaultfilter: 'true'
  },
  {
    type: 'select',
    label: 'languageObj.defectiveReturnLocale.exceptionReason',
    key: 'exceptionReason',
    selectAllClear: true,
    selectList: [
      { label: 'No Hang Tag', value: 'No Hang Tag' },
      { label: 'Scan No Response', value: 'Scan No Response' },
      { label: 'No GI', value: 'No GI' },
      { label: 'Invalid EPC', value: 'Invalid EPC' },
      { label: 'Invalid QR Code', value: 'Invalid QR Code' },
      { label: 'No RSO Submission Date', value: 'No RSO Submission Date' },
      { label: 'No ProductMaster Data', value: 'No ProductMaster Data' },
      { label: '1028 with Shipment', value: '1028 with Shipment' },
      { label: 'No GI & 1028 with Shipment', value: 'No GI & 1028 with Shipment' },
      { label: 'Unknown', value: 'Unknown' }
    ],
    spans: searchItemSpan,
    isdefaultfilter: 'true'
  },
  {
    type: 'select',
    label: 'languageObj.defectiveReturnLocale.epcVariance',
    key: 'epcVariance',
    selectAllClear: true,
    selectList: [
      { label: 'Y', value: 'Y' },
      { label: 'N', value: 'N' }
    ],
    spans: searchItemSpan,
    isdefaultfilter: 'true'
  },
  {
    type: 'input',
    label: 'languageObj.defectiveReturnLocale.rso',
    key: 'rso',
    initialValues: '',
    spans: searchItemSpan,
    isdefaultfilter: 'true'
  },
  {
    type: 'select',
    label: 'languageObj.defectiveReturnLocale.account',
    key: 'account',
    selectAllClear: true,
    selectList: [],
    spans: searchItemSpan,
    isdefaultfilter: 'true'
  },
  {
    type: 'input',
    label: 'languageObj.defectiveReturnLocale.bigGroup',
    key: 'bigGroup',
    initialValues: '',
    spans: searchItemSpan
  },
  {
    type: 'input',
    label: 'languageObj.defectiveReturnLocale.rsoSoldTo',
    key: 'soldTo',
    initialValues: '',
    spans: searchItemSpan
  },
  {
    type: 'input',
    label: 'languageObj.defectiveReturnLocale.rsoShipTo',
    key: 'shipTo',
    initialValues: '',
    spans: searchItemSpan
  },
  {
    type: 'input',
    label: 'languageObj.defectiveReturnLocale.productCode',
    key: 'productCode',
    initialValues: '',
    spans: searchItemSpan
  },
  {
    type: 'input',
    label: 'languageObj.defectiveReturnLocale.epc',
    key: 'epc',
    initialValues: '',
    spans: searchItemSpan
  },
  {
    type: 'input',
    label: 'languageObj.defectiveReturnLocale.qrCode',
    key: 'qrCode',
    initialValues: '',
    spans: searchItemSpan
  },
  {
    type: 'input',
    label: 'languageObj.defectiveReturnLocale.giOwnerGroup',
    key: 'giOwnerGroup',
    initialValues: '',
    spans: searchItemSpan
  },
  {
    type: 'input',
    label: 'languageObj.defectiveReturnLocale.rsoOwnerGroup',
    key: 'rsoOwnerGroup',
    initialValues: '',
    spans: searchItemSpan
  },
  {
    type: 'select',
    label: 'languageObj.defectiveReturnLocale.returnType',
    key: 'returnType',
    selectAllClear: true,
    selectList: [],
    spans: searchItemSpan
  },
  {
    type: 'input',
    label: 'languageObj.defectiveReturnLocale.upc',
    key: 'upc',
    initialValues: '',
    spans: searchItemSpan
  },
  {
    type: 'input',
    label: 'languageObj.defectiveReturnLocale.gledSo',
    key: 'salesOrder',
    initialValues: '',
    spans: searchItemSpan
  },
  {
    type: 'input',
    label: 'languageObj.defectiveReturnLocale.operator',
    key: 'operator',
    initialValues: '',
    spans: searchItemSpan
  },
  {
    type: 'timeRange',
    label: 'languageObj.defectiveReturnLocale.giDate',
    key: 'GiDate',
    format: dateFormat,
    disabledDate: current => current && current > moment().endOf('day'),
    initialValues: [],
    spans: searchItemSpan
  },
  {
    type: 'timeRange',
    label: 'languageObj.defectiveReturnLocale.rsoCreationDate',
    key: 'RsoCreatedDate',
    format: dateFormat,
    disabledDate: current => current && current > moment().endOf('day'),
    initialValues: [],
    spans: searchItemSpan
  },
  {
    type: 'timeRange',
    label: 'languageObj.defectiveReturnLocale.nikeSubmissionDate',
    key: 'ToDate',
    format: dateFormat,
    disabledDate: current => current && current > moment().endOf('day'),
    initialValues: [],
    spans: searchItemSpan
  }
]

const RSODetailReport = () => {
  const mounting = useRef(false)
  const formRef = useRef(null)
  let languageState = useSelector(state => state.commonStore.language)
  const [latestOverdueConfiguration, setLatestOverdueConfiguration] = useState('')
  const [searchList, setSearchList] = useState(searchListInit)
  const [tableList, setTableList] = useState([])
  const [pagination, setPagination] = useState(paginationInit)
  const [queryFlag, setQueryFlag] = useState(false)

  const tableColumns = [
    {
      title: formatMessageNew('languageObj.defectiveReturnLocale.rso'),
      dataIndex: 'rso',
      width: 200,
      render: renderColumn
    },
    {
      title: formatMessageNew('languageObj.defectiveReturnLocale.gledSo'),
      dataIndex: 'salesOrder',
      width: 150,
      render: renderColumn
    },
    {
      title: formatMessageNew('languageObj.defectiveReturnLocale.account'),
      dataIndex: 'account',
      width: 150,
      render: renderColumn
    },
    {
      title: formatMessageNew('languageObj.defectiveReturnLocale.returnType'),
      dataIndex: 'returnType',
      width: 150,
      render: renderColumn
    },
    {
      title: formatMessageNew('languageObj.defectiveReturnLocale.rsoSoldTo'),
      dataIndex: 'soldTo',
      width: 150,
      render: renderColumn
    },
    {
      title: formatMessageNew('languageObj.defectiveReturnLocale.rsoShipTo'),
      dataIndex: 'shipTo',
      width: 150,
      render: renderColumn
    },
    {
      title: formatMessageNew('languageObj.defectiveReturnLocale.rsoOwnerGroup'),
      dataIndex: 'rsoOwnerGroup',
      width: 200,
      render: renderColumn
    },
    {
      title: formatMessageNew('languageObj.defectiveReturnLocale.giOwnerGroup'),
      dataIndex: 'giOwnerGroup',
      width: 200,
      render: renderColumn
    },
    {
      title: formatMessageNew('languageObj.defectiveReturnLocale.bigGroup'),
      dataIndex: 'bigGroup',
      width: 150,
      render: renderColumn
    },
    {
      title: formatMessageNew('languageObj.defectiveReturnLocale.productCode'),
      dataIndex: 'productCode',
      width: 150,
      render: renderColumn
    },
    {
      title: formatMessageNew('languageObj.defectiveReturnLocale.upc'),
      dataIndex: 'upc',
      width: 200,
      render: renderColumn
    },
    {
      title: formatMessageNew('languageObj.defectiveReturnLocale.epc'),
      dataIndex: 'epc',
      width: 300,
      render: renderColumn
    },
    {
      title: formatMessageNew('languageObj.defectiveReturnLocale.qrCode'),
      dataIndex: 'qrCode',
      width: 300,
      render: renderColumn
    },
    {
      title: formatMessageNew('languageObj.defectiveReturnLocale.cartonSequence'),
      dataIndex: 'cartonSequence',
      width: 200,
      render: text => (text && !text.startsWith('vc') ? renderColumn(text) : '')
    },
    {
      title: formatMessageNew('languageObj.defectiveReturnLocale.giDate'),
      dataIndex: 'giDate',
      width: 150,
      render: text => text && renderColumn(dayjs(text).format('YYYY-MM-DD'))
    },
    {
      title: formatMessageNew('languageObj.defectiveReturnLocale.nikeSubmissionDate'),
      dataIndex: 'toDate',
      width: 240,
      render: text => text && renderColumn(dayjs(text).format('YYYY-MM-DD'))
    },
    {
      title: formatMessageNew('languageObj.defectiveReturnLocale.rsoCreationDate'),
      dataIndex: 'rsoCreatedDate',
      width: 200,
      render: text => text && renderColumn(dayjs(text).format('YYYY-MM-DD'))
    },
    {
      title: formatMessageNew('languageObj.defectiveReturnLocale.scanDate'),
      dataIndex: 'scanDate',
      width: 150,
      render: text => text && renderColumn(dayjs(text).format('YYYY-MM-DD'))
    },
    {
      title: formatMessageNew('languageObj.defectiveReturnLocale.validationResult'),
      dataIndex: 'validationResult',
      width: 200,
      render: renderColumn
    },
    {
      title: formatMessageNew('languageObj.defectiveReturnLocale.exceptionReason'),
      dataIndex: 'exceptionReason',
      width: 200,
      render: renderColumn
    },
    {
      title: formatMessageNew('languageObj.defectiveReturnLocale.epcVariance'),
      dataIndex: 'epcVariance',
      width: 150,
      render: text => {
        return (
          <div className="word_break_all" style={{ color: 'red', fontWeight: 'bold' }}>
            {text && text === 'Y' ? text : ''}
          </div>
        )
      }
    },
    {
      title: formatMessageNew('languageObj.defectiveReturnLocale.device'),
      dataIndex: 'deviceCode',
      width: 220,
      render: renderColumn
    },
    {
      title: formatMessageNew('languageObj.defectiveReturnLocale.operator'),
      dataIndex: 'operator',
      width: 150,
      render: renderColumn
    }
  ]

  useEffect(() => {
    getOverdueConfigurationFun()
    getDropDownList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (mounting.current) searchDataFun()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryFlag])

  const getDropDownList = () => {
    const typeKeys = [1, 2, 3, 4]
    // Rso account; validationResult; exceptionReason; epcVariance
    const querys = typeKeys.map(key => getAllDropDownList({ type: key }))
    Promise.all(querys).then(res => {
      searchListInit.forEach(searchItem => {
        switch (searchItem.key) {
          case 'account':
            const accountList = res[0].resultData || []
            const accountOptions = accountList.map(item => ({ label: item, value: item }))
            const accountItem = searchList.find(item => item.key === 'account')
            accountItem.selectList = accountOptions
            break
          // case 'validationResult':
          //   const validationResultList = res[1].resultData || []
          //   const validationResultOptions = validationResultList.map(item => ({ label: item, value: item }))
          //   const validationResultItem = searchList.find(item => item.key === 'validationResult')
          //   validationResultItem.selectList = validationResultOptions
          //   break
          // case 'exceptionReason':
          //   const exceptionReasonList = res[2].resultData || []
          //   const exceptionReasonOptions = exceptionReasonList.map(item => ({ label: item, value: item }))
          //   const exceptionReasonItem = searchList.find(item => item.key === 'exceptionReason')
          //   exceptionReasonItem.selectList = exceptionReasonOptions
          //   break
          // case 'epcVariance':
          //   const epcVarianceList = res[3].resultData || []
          //   const epcVarianceOptions = epcVarianceList.map(item => ({ label: item, value: item }))
          //   const epcVarianceItem = searchList.find(item => item.key === 'epcVariance')
          //   epcVarianceItem.selectList = epcVarianceOptions
          //   break
          case 'returnType':
            const returnTypeList = res[3].resultData || []
            const returnTypeOptions = returnTypeList.map(item => ({ label: item, value: item }))
            const returnTypeItem = searchList.find(item => item.key === 'returnType')
            returnTypeItem.selectList = returnTypeOptions
            break
          default:
            break
        }
      })
      setSearchList([...searchListInit])
    })
  }

  const getOverdueConfigurationFun = () => {
    getOverdueConfiguration().then(res => {
      console.log(res)
      const resultData = res.resultData
      setLatestOverdueConfiguration(resultData)
    })
  }

  const getParams = () => {
    const info = (formRef.current && formRef.current.getSearchValue()) || {}
    const keys = Object.keys(info)
    const params = {}
    keys.forEach(key => {
      if (key.includes('Date')) {
        params[`start${key}`] = formatStartTime(info[key])
        params[`end${key}`] = formatEndTime(info[key])
        return
      }
      params[key] = info[key]
    })
    params.isChinese = languageState === 'zh_CN' ? true : false
    return params
  }

  const searchDataFun = () => {
    const params = {
      ...getParams(),
      size: pagination.pageSize,
      pageNo: pagination.currentPage
    }
    getRsoDetaiReportlList(params).then(res => {
      const dt = res.resultData
      const pg = { ...pagination, total: dt.total }
      setTableList(dt.records)
      setPagination(pg)
    })
  }

  const searchDataBtn = () => {
    mounting.current = true
    const pg = { ...pagination, currentPage: 1 }
    setPagination(pg)
    setQueryFlag(!queryFlag)
  }

  const searchClearDataBtn = () => {
    formRef && formRef.current.clearForm()
    const pg = { ...pagination, currentPage: 1 }
    setPagination(pg)
    setQueryFlag(!queryFlag)
  }

  const handleTableChange = pagina => {
    const params = {
      ...pagination,
      currentPage: pagina.current,
      pageSize: pagina.pageSize
    }
    setPagination(params)
    setQueryFlag(!queryFlag)
  }

  const downLoadFun = () => {
    const params = { ...getParams() }
    exportRsoDetailReport(params).then(res => {
      downLoadFileBlob(res)
    })
  }

  return (
    <div>
      <Card bordered={false} bodyStyle={{ padding: 4 }}>
        <div className="search-bar">
          <SearchBar
            ref={formRef}
            layout={formItemLayout}
            searchList={searchList}
            showCollapseBtn={true}
            showSearchBtn={true}
            showClearBtn={true}
            onSearch={searchDataBtn}
            onClear={searchClearDataBtn}
          />
        </div>
        <div className="content-container">
          <ActionBar onDownload={downLoadFun}>
            <div>
              <span>{`${formatMessageNew('languageObj.defectiveReturnLocale.latestOverdueConfiguration')} `}</span>
              <span style={{ color: latestOverdueConfiguration ? 'black' : 'red' }}>
                {latestOverdueConfiguration
                  ? `<${latestOverdueConfiguration} ${formatMessageNew('languageObj.defectiveReturnLocale.day')}`
                  : `${formatMessageNew('languageObj.defectiveReturnLocale.dateMiss')}`}
              </span>
            </div>
          </ActionBar>
          <AntdTable
            rowKey={(record, index) => record.id || index}
            dataSource={tableList}
            columns={tableColumns}
            // 独一无二的标识，不能重复
            iconTop={20}
            columnsKey="rsoDetailReportColumns"
            pagination={pagination}
            onChange={handleTableChange}
            scroll={{ x: 3200 }}
          />
        </div>
      </Card>
    </div>
  )
}
export default RSODetailReport
